/* eslint-disable no-unused-vars */
/* global $ */
import customSelect from 'custom-select';

/**
 * JS functionality for Biden's Nominees Dashboard and Senator Dashboard
 * pages (mainly filtering these archives)
 */

const nomineesIDLookup = {
	'#nominees-status': 'data-status',
	// uncomment below to enable filtering by diversity on nominees dashboard.
	// '#nominees-diversity': 'data-diversity',
	'#nominees-circuit-district': 'data-circuit-district',
};

const nomineesShowing = {
	'data-status': 'All',
	'data-circuit-district': 'All',
	'data-woman': false,
	'data-lgbtq': false,
	'data-of-color': false,
	// uncomment below to enable filtering by diversity on nominees dashboard.
	// 'data-diversity': 'All',
};

const allowedParams = Object.keys(nomineesShowing);

// set up load more functionality and hide nomnees beyond the chosen number
const loadMoreButton = document.querySelector('button.load-more');
// get the number to show before requiring a load more click - comes from ACF
const numberToShow = document.querySelector('.nominees-dashboard__nominees')
	? parseInt(
			document
				.querySelector('.nominees-dashboard__nominees')
				.getAttribute('data-shown')
	  )
	: 50;

// shouldShow ? null : 'none';

// console.log('Number to show: ' + numberToShow);

// set up function to update the URL with params
// takes an object of the "showing" filters set up for either nominees or
// senators and updates the url parameters with the values assigned by
// the showOrHide functions.
function updateURL(obj) {
	let params = [];
	const paramArray = [];
	for (const [key, value] of Object.entries(obj)) {
		if (value === 'All') {
			// skip default value
			continue;
		}
		if (value === false) {
			// skip default value
			continue;
		}
		paramArray.push(`${key}=${value}`);
		// console.log(paramArray);
	}
	if (paramArray.length > 0) {
		params = paramArray.join('&').replace(/\s/g, '-');
		console.log(params);
		// update the URL with our params
		window.history.replaceState({}, '', location.pathname + '?' + params);
	} else {
		window.history.replaceState({}, '', location.pathname + '');
	}
}

// init the shown nominees array for hiding past teh given number (usually 50) - numberToShow
let shownNominees = Array.from(
	document.querySelectorAll('.nominees-dashboard__nominee')
);
// add the filtered class to start
// shownNominees.forEach((shownNominee) => {
// 	shownNominee.classList.add('filtered');
// });

// set up function to update the array of nominees that match the filters
function updateShownNomineesArray() {
	// array should now match the filters
	shownNominees = Array.from(
		document.querySelectorAll('.nominees-dashboard__nominee.filtered')
	);
	// console.log(shownNominees);
	// console.log('has .fitlered ' + shownNominees.length);
	// check if the number of nominees that match the filters is greater than the number we want to show initially
	if (shownNominees.length > numberToShow) {
		console.log(`hiding elements beyond ${numberToShow}`);
		$(shownNominees).slice(numberToShow).hide();
		if ($('.filtered:hidden')) {
			$(loadMoreButton).show();
			/* eslint-disable no-unused-expressions */
		}
	} else {
		// hide the load more button if we're already showing all the filtered nominees
		$(loadMoreButton).hide();
	}
}

// call the function once on load
updateShownNomineesArray();
// console.log(shownNominees);

// load more nominees on button click
if (loadMoreButton) {
	loadMoreButton.addEventListener('click', (e) => {
		e.preventDefault;
		// console.log($('.filtered:hidden').length + ' are hidden');
		// we load the next batch by the chosen increment
		$('.filtered:hidden').slice(0, numberToShow).show();
		if ($('.filtered:hidden').length < 1) {
			// console.log('no more');
			$(loadMoreButton).hide();
		}
	});
}

function showOrHideNominees() {
	const nominees = Array.from(
		document.querySelectorAll('.nominees-dashboard__nominee')
	);

	nominees.forEach((nominee) => {
		const shouldShow = Object.keys(nomineesShowing).every((attr) => {
			if (nomineesShowing[attr] === 'All') return true;
			if (attr === 'data-woman') {
				return nomineesShowing[attr]
					? nominee.getAttribute('data-woman')
					: true;
			}
			if (attr === 'data-lgbtq') {
				return nomineesShowing[attr]
					? nominee.getAttribute('data-lgbtq')
					: true;
			}
			if (attr === 'data-of-color') {
				return nomineesShowing[attr]
					? nominee.getAttribute('data-of-color')
					: true;
			}
			return nominee.getAttribute(attr) === nomineesShowing[attr];
		});

		nominee.style.display = shouldShow ? null : 'none';
		if (shouldShow) {
			nominee.classList.add('filtered');
		}
		if (!shouldShow) {
			nominee.classList.remove('filtered');
		}
	});
	// updated the filtered class so we know how many to hide/set up the load more button
	updateShownNomineesArray();
}

const senatorsIDLookup = {
	'#senator-remus': 'data-remus',
	'#senator-commission': 'data-commission',
};

const senatorsShowing = {
	'data-remus': 'All',
	'data-commission': 'All',
};

function showOrHideSenators() {
	const senators = Array.from(
		document.querySelectorAll('.senator-scorecard__senator')
	);

	senators.forEach((senator) => {
		const shouldShow = Object.keys(senatorsShowing).every((attr) => {
			if (senatorsShowing[attr] === 'All') return true;
			return senator.getAttribute(attr) === senatorsShowing[attr];
		});

		senator.style.display = shouldShow ? null : 'none';
	});
}

if (
	document.body.classList.contains(
		'page-template-template-nominees-dashboard'
	)
) {
	// change what should show based upon any URL params
	// set up URL search params
	const urlParams = new URLSearchParams(location.search);

	urlParams.forEach((value, key) => {
		// skip any params that aren't in the allowedParams array
		if (allowedParams.indexOf(key) === -1) {
			return;
		}
		if (key === 'data-woman' && value === 'true') {
			nomineesShowing[`${key}`] = true;
			// document.querySelector('#nominees-women').value = true;
			document.querySelector('#nominees-women').checked = true;
		} else {
			nomineesShowing[`${key}`] = value.replace('-', ' ');
		}
		if (key === 'data-of-color' && value === 'true') {
			nomineesShowing[`${key}`] = true;
			document.querySelector('#nominees-of-color').checked = true;
		} else {
			nomineesShowing[`${key}`] = value.replace('-', ' ');
		}
		if (key === 'data-lgbtq' && value === 'true') {
			nomineesShowing[`${key}`] = true;
			document.querySelector('#nominees-lgbtq').checked = true;
		} else {
			nomineesShowing[`${key}`] = value.replace('-', ' ');
		}
	});
	// call the show or hide function to update the object
	showOrHideNominees();

	// set up functionality for each filter
	Object.keys(nomineesIDLookup).forEach((id) => {
		document.querySelector(id).value =
			nomineesShowing[nomineesIDLookup[id]];
		customSelect(id);
		document.querySelector(id).addEventListener('change', function () {
			nomineesShowing[nomineesIDLookup[id]] = this.value;
			showOrHideNominees();
			updateURL(nomineesShowing);
		});
	});

	document
		.getElementById('nominees-women')
		.addEventListener('change', function () {
			nomineesShowing['data-woman'] = this.checked;
			showOrHideNominees();
			updateURL(nomineesShowing);
		});
	document
		.getElementById('nominees-of-color')
		.addEventListener('change', function () {
			nomineesShowing['data-of-color'] = this.checked;
			showOrHideNominees();
			updateURL(nomineesShowing);
		});
	document
		.getElementById('nominees-lgbtq')
		.addEventListener('change', function () {
			nomineesShowing['data-lgbtq'] = this.checked;
			showOrHideNominees();
			updateURL(nomineesShowing);
		});
}

if (
	document.body.classList.contains('page-template-template-senate-scorecard')
) {
	// update what should show based upon any URL params
	// set up URL search params
	const urlParams = new URLSearchParams(location.search);

	urlParams.forEach((value, key) => {
		// console.log(value, key);
		senatorsShowing[`${key}`] = value.replace('-', ' ');
	});
	// call the show or hide function to update the object
	showOrHideSenators();

	Object.keys(senatorsIDLookup).forEach((id) => {
		document.querySelector(id).value =
			senatorsShowing[senatorsIDLookup[id]];
		customSelect(id);
		document.querySelector(id).addEventListener('change', function () {
			senatorsShowing[senatorsIDLookup[id]] = this.value;
			showOrHideSenators();
			updateURL(senatorsShowing);
		});
	});
}
